import path from 'path';
import { stringifyUrl } from '@/utils/libs/query-string/stringify';
/**
 * Routes コンポーネントでまとめられた Route コンポーネントの子要素のパスを取得
 * @description path から root の path を削除する
 * @example /root/child -> /child
 * @param path root になる path
 * @returns
 */
export const getChildPath = (childPath, rootPath) => path.relative(rootPath.replace(/\/\*$/, ''), childPath);
/* eslint-disable sort-keys-fix/sort-keys-fix */
/**
 * ページのパスを定義
 */
export const pagePath = {
    /** TOP */
    top: () => '/',
    /** コンサルタント TOP */
    forConsultant: () => `/for_consultant`,
    /** ログイン */
    login: () => `/login`,
    /** 新規登録 */
    registration: {
        /** 新規登録: 入力 */
        index: () => `/registration`,
        /** 新規登録: 完了（企業） */
        completeClient: () => `/registration/complete_client`,
        /** 新規登録: 完了（コンサル） */
        completeConsultant: () => `/registration/complete_consultant`,
    },
    /** 名刺登録 */
    card: {
        /** 名刺登録: 入力 */
        token: (token) => `/card/${token}`,
        /** 名刺登録: 完了 */
        complete: () => `/card/complete`,
    },
    /** パスワード */
    password: {
        /** パスワード: 初期設定 */
        setting: {
            /** パスワード初期設定: 入力 */
            token: (token) => `/password/setting/${token}`,
            /** パスワード初期設定: 完了 */
            complete: () => `/password/setting/complete`,
        },
        /** パスワード再発行 */
        reset: {
            /** パスワード再発行: 依頼入力 */
            index: () => `/password/reset`,
            /** パスワード再発行: 依頼完了 */
            requested: () => `/password/reset/requested`,
            /** パスワード再発行: 再設定入力 */
            token: (token) => `/password/reset/${token}`,
            /** パスワード再発行: 再設定完了 */
            complete: () => `/password/reset/complete`,
        },
    },
    /** 会社概要 */
    company: () => `/company`,
    /** 利用規約 */
    terms: () => `/terms`,
    /** PROFFIT SEARCH 利用規約 */
    termsProffitSearch: () => `/terms_proffitsearch`,
    /** 特特定商取引法 */
    law: () => `/law`,
    /** プライバシーポリシー */
    privacy: () => `/privacy`,
    /** FAQ */
    faq: () => `/faq`,
    /** お問い合わせ */
    contact: {
        /** 各種お問い合わせ */
        index: () => `/contact`,
        /** カジュアル相談会: rootPath */
        casualRoot: () => `/contact/casual/*`,
        /** カジュアル相談会: 入力 */
        casual: () => `/contact/casual`,
        /** カジュアル相談会: 確認 */
        casualConfirm: () => `/contact/casual/confirm`,
        /** カジュアル相談会: 完了 */
        casualComplete: () => `/contact/casual/complete`,
        /** コンサル選定のご相談: rootPath */
        consultationRoot: () => `/contact/consultation/*`,
        /** コンサル選定のご相談: 入力 */
        consultation: () => `/contact/consultation`,
        /** コンサル選定のご相談: 確認 */
        consultationConfirm: () => `/contact/consultation/confirm`,
        /** コンサル選定のご相談: 完了 */
        consultationComplete: () => `/contact/consultation/complete`,
        /** その他のお問合せ: rootPath */
        otherRoot: () => `/contact/other/*`,
        /** その他のお問合せ */
        other: () => `/contact/other`,
        /** その他のお問合せ: 確認 */
        otherConfirm: () => `/contact/other/confirm`,
        /** その他のお問合せ: 完了 */
        otherComplete: () => `/contact/other/complete`,
    },
    /** ニュース */
    release: {
        /** 一覧 */
        index: () => `/release`,
        /** 詳細 */
        detail: (id) => `/release/${id}`,
    },
    /** お知らせ一覧 */
    news: {
        list: () => `/news`,
    },
    /** プロジェクト事例 */
    solutions: {
        /** プロジェクト事例: 検索 */
        search: () => `/solutions/search`,
        /** プロジェクト事例: 詳細 */
        detail: (id) => `/solutions/${id}`,
        /** プロジェクト事例: 申し込み 入力 */
        order: (id) => `/solutions/${id}/order`,
        /** プロジェクト事例: 申し込み 確認 */
        orderConfirm: (id) => `/solutions/${id}/order/confirm`,
        /** プロジェクト事例: 申し込み 完了 */
        orderComplete: (id) => `/solutions/${id}/order/complete`,
        /** プロジェクト事例: PROFFITに相談 入力 */
        proffitOrder: (id) => `/solutions/${id}/proffit_order`,
        /** プロジェクト事例: PROFFITに相談 完了 */
        proffitOrderComplete: (id) => `/solutions/${id}/proffit_order/complete`,
    },
    /** コンサル検索 */
    consultant: {
        /** コンサル検索: TOP */
        top: () => `/consultant`,
        /** コンサル検索: 検索結果一覧 */
        search: () => `/consultant/search`,
        /** コンサル検索: コンサルタント詳細 */
        detail: (id) => `/consultant/${id}`,
        /** コンサル検索: PROFFIT SEARCH スライド詳細 */
        proffitSearchDetail: (id) => `/consultant/proffit_search/${id}`,
        /** コンサル検索: ユーザー資料一覧（管理者用） */
        slideDetail: (id) => `/consultant/slide/page/${id}`,
    },
    /** コンサルタント会社 */
    consultantUnit: {
        /** コンサルタント会社: 詳細 */
        detail: (id) => `/consultant_unit/${id}`,
    },
    /** フリーコンサルタント */
    freeConsultant: {
        /** フリーコンサルタント: 詳細 */
        detail: (id) => `/free_consultant/${id}`,
    },
    /**
     * マイページ
     * NOTE: ユーザー種別によりルーティングが変わるため例外的にネストが深くなっています
     */
    mypage: {
        root: () => `/mypage/*`,
        /** 企業マイページ */
        client: {
            /** 企業マイページ */
            index: () => `/mypage`,
            /** 企業マイページ: お気に入り */
            favorites: () => `/mypage/favorites`,
            /** 企業マイページ: プロジェクト事例比較 */
            comparison: () => `/mypage/comparison`,
            /** 企業マイページ: プロフィール編集 */
            profile: () => `/mypage/profile`,
            /** 企業マイページ: コンサル選定ご相談フォーム 入力 */
            consultation: () => `/mypage/consultation`,
            /** 企業マイページ: コンサル選定ご相談フォーム 確認 */
            consultationConfirm: () => `/mypage/consultation/confirm`,
            /** 企業マイページ: 提案募集状況の確認 */
            project: () => `/mypage/project`,
            /** 企業マイページ: 匿名コンサルホットライン */
            hotline: () => `/mypage/hotline`,
        },
        /** コンサルタントマイページ */
        professional: {
            /** コンサルタントマイページ */
            index: () => `/mypage`,
            /** コンサルタントマイページ: プロフィール編集 */
            profile: () => `/mypage/profile`,
            /** コンサルタントマイページ: プロジェクト事例登録 */
            solutionsAdd: (id) => `/mypage/solutions/add${id ? `/${id}` : ''}`,
            /** コンサルタントマイページ: プロジェクト事例修正申請 */
            solutionsEdit: (id) => `/mypage/solutions/edit/${id}`,
            /** コンサルタントマイページ: コンサルタントの紹介 */
            introductions: () => `/mypage/introductions`,
            /** コンサルタントマイページ: コンサルタントの紹介完了 */
            introductionsComplete: () => `/mypage/introductions/complete`,
        },
        /** フリーコンサルタントマイページ */
        freeProfessional: {
            /** フリーコンサルタントマイページ */
            index: () => `/mypage`,
            /** フリーコンサルタントマイページ: プロフィール編集 */
            profile: () => `/mypage/profile`,
        },
    },
    /** PROFFIT SEARCH */
    proffitSearch: {
        /** PROFFIT SEARCH: ルート path */
        root: () => `/proffit_search/*`,
        /** PROFFIT SEARCH: LP */
        lp: () => `/proffit_search/lp`,
        /** PROFFIT SEARCH: TOP */
        top: () => `/proffit_search`,
        /** PROFFIT SEARCH: 端末登録 */
        registrationDevice: (id) => `/proffit_search/registration_device/${id}`,
        /** PROFFIT SEARCH: 端末再登録 */
        reregistrationDevice: () => `/proffit_search/registration_device`,
        /** PROFFIT SEARCH: スライド検索 */
        search: () => `/proffit_search/search`,
        /** PROFFIT SEARCH: スライド詳検索結果 */
        slideDetail: (id) => `/proffit_search/slide/${id}`,
        /** PROFFIT SEARCH: Myフォルダ */
        folder: () => `/proffit_search/folder`,
        /** PROFFIT SEARCH: Myフォルダ詳細 */
        folderDetail: (id) => `/proffit_search/folder/${id}`,
        /** PROFFIT SEARCH: 受信フォルダ */
        receiveFolder: () => `/proffit_search/receive_folder`,
        /** PROFFIT SEARCH: 受信メッセージ詳細 */
        receiveFolderDetail: (id) => `/proffit_search/receive_folder/${id}`,
        /** PROFFIT SEARCH: 共有履歴 */
        shareHistory: () => `/proffit_search/share_history`,
        /** PROFFIT SEARCH: 共有ファイル */
        shareHistoryDetail: (id) => `/proffit_search/share_history/${id}`,
        /** PROFFIT SEARCH: アップロード履歴 */
        uploadHistory: () => `/proffit_search/upload_history`,
        /** PROFFIT SEARCH: アカウント管理 プラン */
        accountPlan: () => `/proffit_search/account_plan`,
        /** PROFFIT SEARCH: アカウント管理 リスト */
        accountList: () => `/proffit_search/account_list`,
        /** PROFFIT SEARCH: アカウント追加 */
        accountAdd: () => `/proffit_search/account_add`,
        /** PROFFIT SEARCH: スライド追加 */
        slideAdd: () => `/proffit_search/slide_add`,
    },
    /**
     * 提案
     * NOTE: ユーザー種別によりルーティングが変わるため例外的にネストが深くなっています
     */
    project: {
        root: () => `/project/*`,
        /** 提案: コンサルタント */
        professional: {
            /** 提案コンサルタント: 一覧 */
            list: () => `/project/professional`,
            /** 提案コンサルタント: 詳細 */
            detail: (id) => `/project/professional/${id}`,
            /** 提案コンサルタント: 条件相談 */
            negotiate: (id) => `/project/professional/${id}/negotiate`,
            /** 提案コンサルタント: ファイル共有 */
            file: (id) => `/project/professional/${id}/file/message`,
            /** 提案コンサルタント: 提案 ルート */
            offerRoot: (id) => `/project/professional/${id}/offer/*`,
            /** 提案コンサルタント: 提案内容入力 */
            offer: (id) => `/project/professional/${id}/offer`,
            /** 提案コンサルタント: 提案内容入力 支払い */
            offerPayment: (id) => `/project/professional/${id}/offer/payment`,
            /** 提案コンサルタント: 提案内容 確認 */
            offerConfirm: (id) => `/project/professional/${id}/offer/confirm`,
            /** 提案コンサルタント: 提案内容 完了 */
            offerComplete: (id) => `/project/professional/${id}/offer/complete`,
            /** 提案コンサルタント: 提出後 確認 */
            offered: (id) => `/project/professional/${id}/offered`,
            /** 提案コンサルタント: 質問 編集 */
            question: (id) => `/project/professional/${id}/question`,
            /** 提案コンサルタント: 質問 追加 */
            questionAdd: (id) => `/project/professional/${id}/question/add`,
            /** 提案コンサルタント: 質問 確認 */
            questionConfirm: (id) => `/project/professional/${id}/question/confirm`,
        },
        /** 提案: クライアント */
        client: {
            /** 提案クライアント: 詳細（リダイレクト用） */
            detail: (id) => `/project/client/${id}`,
            /** 提案クライアント: 提案を集める */
            offer: (id) => `/project/client/${id}/offer`,
            /** 提案クライアント: 提案を集める 詳細 */
            offerDetail: (id, viewRequestId) => `/project/client/${id}/offer/${viewRequestId}`,
            /** 提案クライアント: 質問一覧 */
            question: (id) => `/project/client/${id}/question`,
            /** 提案クライアント: 条件相談 */
            negotiate: (id) => `/project/client/${id}/negotiate`,
            /** 提案クライアント: ファイル共有 ルート */
            fileRoot: (id) => `/project/client/${id}/file/*`,
            /** 提案クライアント: ファイル共有（一括送付） */
            fileAll: (id) => `/project/client/${id}/file`,
            /** 提案クライアント: ファイル共有（一括送付確認） */
            fileAllConfirm: (id) => `/project/client/${id}/file/confirm`,
            /** 提案クライアント: ファイル共有（個別ID：データなし） */
            fileNoMessage: (id) => `/project/client/${id}/file/no_message`,
            /** 提案クライアント: ファイル共有（個別ID） */
            fileOneMessage: (id, viewRequestId) => `/project/client/${id}/file/message/${viewRequestId}`,
            /** 提案クライアント: 面談先を決める 入力 */
            interview: (id) => `/project/client/${id}/interview`,
            /** 提案クライアント: 面談先を決める 提案一覧 */
            interviewList: (id) => `/project/client/${id}/interview/view`,
            /** 提案クライアント: 面談先を決める 面談日程 入力 */
            interviewInput: (id) => `/project/client/${id}/interview/input`,
            /** 提案クライアント: 面談先を決める 面談日程 確認 */
            interviewConfirm: (id) => `/project/client/${id}/interview/confirm`,
            /** 提案クライアント: 発注先を決める */
            order: (id) => `/project/client/${id}/order`,
        },
    },
    /** コラム */
    column: {
        /** コラム: 一覧 */
        list: () => `/column`,
        /** コラム: 詳細 */
        detail: (weight, code) => `/column/${weight}/${code}`,
    },
    /** DL資料 */
    document: {
        /** DL資料: 一覧 */
        list: () => `/document`,
        /** DL資料: 詳細 */
        detail: (weight, id) => `/document/${weight}/${id}`,
    },
    /** DL資料: DLページ */
    documentDownload: (code) => `/document_download/${code}`,
    /** セミナー */
    seminar: {
        /** セミナー: 一覧 */
        list: () => `/seminar`,
        /** セミナー: 追加 */
        add: () => `/seminar/add`,
        /** セミナー: 詳細 Root */
        detailRoot: (id) => `/seminar/${id}/*`,
        /** セミナー: 編集 */
        edit: (id) => `/seminar/${id}/edit`,
        /** セミナー: 申し込み入力 */
        request: (id) => `/seminar/${id}/request`,
        /** セミナー: 申し込み確認 */
        requestConfirm: (id) => `/seminar/${id}/request/confirm`,
        /** セミナー: 申し込み完了 */
        requestComplete: (id) => `/seminar/${id}/request/complete`,
    },
    /** 選定支援事例 */
    case: {
        /** 選定支援事例: 一覧 */
        list: () => `/case`,
        /** 選定支援事例: 詳細 */
        detail: (id) => `/case/${id}`,
    },
    /** ホットライン */
    hotline: {
        root: () => `/hotline/*`,
        /** ホットライン: LP */
        lp: () => `/hotline/lp`,
        client: {
            clientRoot: () => `/hotline/client/*`,
            /** ホットラインクライアント: 投稿: rootPath */
            createRoot: () => `/hotline/client/create/*`,
            /** ホットラインクライアント: 投稿入力 */
            createInput: () => `/hotline/client/create`,
            /** ホットラインクライアント: 投稿確認 */
            createConfirm: () => `/hotline/client/create/confirm`,
            /** ホットラインクライアント: 投稿完了 */
            createComplete: () => `/hotline/client/create/complete`,
            /** ホットラインクライアント: 投稿編集 rootPath */
            editRoot: (id) => `/hotline/client/edit/${id}/*`,
            /** ホットラインクライアント: 投稿編集 入力 */
            editInput: (id) => `/hotline/client/edit/${id}`,
            /** ホットラインクライアント: 投稿投稿 確認 */
            editConfirm: (id) => `/hotline/client/edit/${id}/confirm`,
            /** ホットラインクライアント: 投稿投稿 完了 */
            editComplete: (id) => `/hotline/client/edit/${id}/complete`,
            /** ホットラインクライアント: 詳細 */
            detailRoot: (id) => `/hotline/client/${id}/*`,
            /** ホットラインクライアント: 詳細 */
            detail: (id) => `/hotline/client/${id}`,
            /** ホットラインクライアント: 詳細 面談実施 */
            detailMeeting: (id) => `/hotline/client/${id}/meeting`,
            /** ホットラインクライアント: 詳細 相談 */
            detailNegotiate: (id) => `/hotline/client/${id}/negotiate`,
            /** ホットラインクライアント: 投稿: rootPath */
            reorderRoot: (id, requestId) => `/hotline/client/${id}/reorder/${requestId}/*`,
            /** ホットラインクライアント: 相談日程再申し込み入力 */
            reorderInput: (id, requestId) => `/hotline/client/${id}/reorder/${requestId}`,
            /** ホットラインクライアント: 相談日程再申し込み確認 */
            reorderConfirm: (id, requestId) => `/hotline/client/${id}/reorder/${requestId}/confirm`,
            /** ホットラインクライアント: 相談日程再申し込み完了 */
            reorderComplete: (id, requestId) => `/hotline/client/${id}/reorder/${requestId}/complete`,
            /** ホットラインクライアント: 今後の進め方入力 rootPath */
            contactRoot: (id, requestId) => `/hotline/client/${id}/contact/${requestId}/*`,
            /** ホットラインクライアント: 今後の進め方入力 */
            contactInput: (id, requestId) => `/hotline/client/${id}/contact/${requestId}`,
            /** ホットラインクライアント: 今後の進め方確認 */
            contactConfirm: (id, requestId) => `/hotline/client/${id}/contact/${requestId}/confirm`,
            /** ホットラインクライアント: 今後の進め方完了 */
            contactComplete: (id, requestId) => `/hotline/client/${id}/contact/${requestId}/complete`,
        },
        professional: {
            professionalRoot: () => `/hotline/professional/*`,
            /** ホットラインコンサル: 一覧 */
            list: () => `/hotline/professional`,
            /** ホットラインコンサル: 詳細 ルート */
            detailRoot: (id) => `/hotline/professional/${id}/*`,
            /** ホットラインコンサル: 詳細 */
            detail: (id) => `/hotline/professional/${id}`,
            /** ホットラインコンサル: 初回返信 入力 */
            firstReplyRoot: (id) => `/hotline/professional/${id}/first_reply/*`,
            /** ホットラインコンサル: 初回返信 入力 */
            firstReplyInput: (id) => `/hotline/professional/${id}/first_reply`,
            /** ホットラインコンサル: 初回返信 確認 */
            firstReplyConfirm: (id) => `/hotline/professional/${id}/first_reply/confirm`,
            /** ホットラインコンサル: 初回返信 完了 */
            firstReplyComplete: (id) => `/hotline/professional/${id}/first_reply/complete`,
            /** ホットラインコンサル: 詳細 相談 */
            detailNegotiate: (id) => `/hotline/professional/${id}/negotiate`,
            /** ホットラインコンサル: 詳細 面談実施 */
            detailMeeting: (id) => `/hotline/professional/${id}/meeting`,
        },
    },
    /** 通話機能 */
    call: {
        /** 通話機能：匿名ホットライン */
        hotline: {
            /** 通話機能：匿名ホットライン クライアント */
            client: {
                /** 通話機能：匿名ホットライン クライアント 通話 */
                meeting: (code) => stringifyUrl({
                    query: { code },
                    url: '/call/hotline/meeting/client',
                }),
                /** 通話機能：匿名ホットライン クライアント 通話テスト */
                test: (code) => stringifyUrl({
                    query: { code },
                    url: '/call/hotline/test/client',
                }),
            },
            /** 通話機能：匿名ホットライン コンサルタント */
            offer: {
                /** 通話機能：匿名ホットライン コンサルタント 通話 */
                meeting: (code) => stringifyUrl({
                    query: { code },
                    url: '/call/hotline/meeting/offer',
                }),
                /** 通話機能：匿名ホットライン コンサルタント 通話テスト */
                test: (code) => stringifyUrl({
                    query: { code },
                    url: '/call/hotline/test/offer',
                }),
            },
        },
    },
    /** メンテナンス */
    maintenance: () => `/maintenance`,
    /** 404 */
    notfound: () => `/error/notfound`,
};
/* eslint-enable sort-keys-fix/sort-keys-fix */
